import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';

@Component({
  selector: 'app-purchase',
  templateUrl: './purchase.component.html',
  styleUrls: ['./purchase.component.scss']
})
export class PurchaseComponent {
  masterDataChildren: Route[] = [];

  constructor(private router: Router) { }

  ngOnInit(): void {
    const masterDataRoute = this.router.config.find(r => r.path === 'purchase');

    // Get only first-level children
    this.masterDataChildren = masterDataRoute?.children ?? [];
  }
}
